import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm text-red-600"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-6 text-sm text-red-600"
}
const _hoisted_3 = {
  key: 1,
  "data-locked-service-area": "",
  class: "text-sm text-gray-600"
}
const _hoisted_4 = { class: "space-y-1" }
const _hoisted_5 = {
  "data-preview-url": "",
  class: "text-sm text-gray-600 truncate"
}
const _hoisted_6 = {
  "data-preview-title": "",
  class: "text-lg text-blue-800"
}
const _hoisted_7 = { class: "text-sm text-gray-600" }

import { computed, onMounted, ref } from 'vue'

import InputArea from '@/components/neue/InputArea.vue'
import InputField from '@/components/neue/InputField.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import SaveBar from '@/components/SaveBar.vue'
import { useStorefrontSeo } from '@/composables/useStorefrontSeo'
import { useUnsavedChanges } from '@/composables/useUnsavedChanges'

import SettingsShell from './SettingsShell.vue'


export default {
  __name: 'SettingsSearchAndAi',
  setup(__props) {

const loading = ref(true)
const loadError = ref('')
const saveError = ref('')
const { form, suggestions, preview, serviceAreaEditable, load, save: persist } = useStorefrontSeo()
const { hasUnsavedChanges, reload } = useUnsavedChanges([form])

const serviceAreaHint = computed(() =>
  suggestions.service_area ? `Leave blank to use "${suggestions.service_area}".` : 'e.g. Dallas-Fort Worth'
)

const lockedServiceAreaText = computed(() => {
  const area = suggestions.service_area
    ? `"${suggestions.service_area}", from your profile city or pickup location`
    : 'your profile city'
  return `As a franchise location, your storefront uses ${area}. Your location name on the franchise page stays as it is.`
})

const descriptionHint = computed(() => {
  if (form.description) return `${form.description.length} characters`
  return suggestions.description
    ? 'Leave blank to use the suggestion in the box.'
    : 'e.g. Chef-made meals, delivered weekly across Dallas-Fort Worth.'
})

const loadSaved = () =>
  reload([load()]).catch(() => {
    loadError.value = "Couldn't load your Search & AI settings. Please refresh the page."
  })

const discard = () => {
  saveError.value = ''
  return reload([load()]).catch(() => {
    saveError.value = "Couldn't reload your saved settings. Please try again."
  })
}

const save = () => {
  saveError.value = ''
  return reload([persist()]).catch(error => {
    saveError.value = error.response?.data?.errors?.[0] || 'Unable to save right now. Please try again.'
  })
}

onMounted(() =>
  loadSaved().finally(() => {
    loading.value = false
  })
)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingsShell, null, {
    savebar: _withCtx(() => [
      _createVNode(SaveBar, {
        "has-unsaved-changes": _unref(hasUnsavedChanges),
        onOnDiscard: discard,
        onOnSave: save
      }, null, 8, ["has-unsaved-changes"])
    ]),
    default: _withCtx(() => [
      _createVNode(NeueLoading, { loading: loading.value }, {
        default: _withCtx(() => [
          (loadError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(loadError.value), 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (saveError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(saveError.value), 1))
                  : _createCommentVNode("", true),
                _createVNode(SettingsSection, {
                  title: "Service area",
                  description: "The city or region you serve. Google and AI assistants use it to match you with people searching nearby."
                }, {
                  default: _withCtx(() => [
                    (_unref(serviceAreaEditable))
                      ? (_openBlock(), _createBlock(InputField, {
                          key: 0,
                          modelValue: _unref(form).service_area,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(form).service_area) = $event)),
                          name: "Service area",
                          description: serviceAreaHint.value,
                          "description-above": ""
                        }, null, 8, ["modelValue", "description"]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(lockedServiceAreaText.value), 1))
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Short description",
                  description: "One or two sentences about your business. Google shows about the first 160 characters."
                }, {
                  default: _withCtx(() => [
                    _createVNode(InputArea, {
                      modelValue: _unref(form).description,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(form).description) = $event)),
                      name: "Short description",
                      rows: "3",
                      placeholder: _unref(suggestions).description,
                      description: descriptionHint.value,
                      "description-above": ""
                    }, null, 8, ["modelValue", "placeholder", "description"])
                  ]),
                  _: 1
                }),
                _createVNode(SettingsSection, {
                  title: "Google preview",
                  description: "How your storefront can appear on Google. It updates when you save."
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(preview).url), 1),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(preview).title), 1),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(preview).description), 1)
                    ])
                  ]),
                  _: 1
                })
              ], 64))
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

}